const CONSTANTS = {
    ON_AUTH_IS_LOADING: 'auth/ON_AUTH_IS_LOADING',
    ON_AUTH_IS_AUTHORIZED: 'auth/ON_AUTH_IS_AUTHORIZED',
    ON_AUTH_TOKEN: 'auth/ON_AUTH_TOKEN',
    ON_AUTH_USER: 'auth/ON_AUTH_USER',
    ON_AUTH_LOGOUT: 'auth/ON_AUTH_LOGOUT',
    ON_AUTH_EDIT_MODAL_IS_SHOWN: 'auth/ON_AUTH_EDIT_MODAL_IS_SHOWN',
    ON_AUTH_EDIT_MODAL_IS_LOADING: 'auth/ON_AUTH_EDIT_MODAL_IS_LOADING',
    ON_AUTH_CHANGE_PASSWORD_IS_SHOWN: 'auth/ON_AUTH_CHANGE_PASSWORD_IS_SHOWN',
    ON_AUTH_CHANGE_PASSWORD_IS_LOADING: 'auth/ON_AUTH_CHANGE_PASSWORD_IS_LOADING',
    ON_AUTH_CHANGE_PASSWORD_ERROR: 'auth/ON_AUTH_CHANGE_PASSWORD_ERROR'
};

export { CONSTANTS };
